import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getRedactDataRegistryId = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.redactDataRegistryId;
};
export default getRedactDataRegistryId;
